import { Alert, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";

import ProvidersScreen from "./ProvidersScreen";
import SchedulingSettingsHeader from "../../components/SchedulingSettingsHeader";
import { selectUser } from "../../../../features/auth/authSlice";
import { useGetProvidersAvailabilityMutation } from "../../../../features/organisation/organisationApiSlice";
import { useSchedulerStore } from "../../../../context/scheduler.store";
import { useSelector } from "react-redux";
import UploadProviderSchedulesModal from "../ProvidersConfig/components/UploadProviderSchedulesModal";

const ProvidersConfig = () => {
  const [opaque, setOpaque] = useState(false);
  const user = useSelector(selectUser);
  const providers = useSchedulerStore((state) => state.providers);
  const setProviders = useSchedulerStore((state) => state.setProviders);

  const [getProvidersAvailability] = useGetProvidersAvailabilityMutation();
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("Something went wrong");
  const [severity, setSeverity] = React.useState("error");
  const [statuses, setStatuses] = useState([]);
  const [statusFilter, setStatusFilter] = useState(["ACTIVE"]);
  const [isBulkUploadModalOpen, setIsBulkUploadModalOpen] = useState(false);

  const fetchProviders = async () => {
    try {
      const { data, statuses } = await getProvidersAvailability(
        { organisationId: user.organisation.id, status: statusFilter }
      ).unwrap();

      setProviders(data);
      setStatuses(statuses);
    } catch (error) {
      setProviders([]);
      console.log(error.response);
      console.error(error.data.message);
    }
  };
  const showAlert = (msg, severity) => {
    setOpen(true);
    setMessage(msg);
    setSeverity(severity);
  };

  useEffect(() => {
    fetchProviders();
  }, [statusFilter]);

  return (
    <div
      // className="flex relative flex-col w-full h-screen"
      className="flex overflow-hidden relative flex-col w-full"
    >
      <SchedulingSettingsHeader
        title={"Provider Availability"}
        button={user?.permissions?.includes('provider_settings.bulk_provider_availability') ? "Bulk Upload" : null}
        onBtnClick={() => {
          setIsBulkUploadModalOpen(true)
        }}
      />
      <ProvidersScreen
        setOpaque={setOpaque}
        providers={providers}
        setProviders={setProviders}
        showAlert={showAlert}
        statuses={statuses}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
      />
      {isBulkUploadModalOpen && user?.permissions?.includes('provider_settings.bulk_provider_availability') && (
        <UploadProviderSchedulesModal   fetchProviders={() => fetchProviders()} showAlert={showAlert} isOpen={isBulkUploadModalOpen} onClose={() => setIsBulkUploadModalOpen(false)} />
      )
      }
      <Snackbar
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={open}
        autoHideDuration={5000}
        message={message ? message : "Something went wrong"}
        severity="error"
      >
        <Alert
          onClose={() => setOpen(false)}
          severity={severity ? severity : "error"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message ? message : "Something went wrong"}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ProvidersConfig;
